export enum PaymentCartTypeType {
    MAWB,
    HAWB,
    NONE,
}

export const PaymentCartTypeDescription = Object.freeze({
    [PaymentCartTypeType.MAWB]: 'mawb',
    [PaymentCartTypeType.HAWB]: 'hawb',
    [PaymentCartTypeType.NONE]: 'none',
});
